import React from 'react';
import * as Icon from 'react-feather';

const PawiOzellikler = () => {
    return (
        <div className="features-area pt-80 pb-50 bg-f9f6f6">
            <div className="container">
                <div className="section-title">
                    <h2>Özellikler</h2>
                    <p>
                        Pawi Net; evcil hayvanların aşı, muayene, hastalık ve tedavi süreçlerini düzenli olarak takip etmenizi sağlayan veteriner klinik yönetim yazılımıdır. Hasta geçmişinden ilaç stoklarına kadar kliniğinizde ihtiyaç duyduğunuz bilgilere tek ekran üzerinden kolayca ulaşabilirsiniz.
                    </p>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon">
                                <Icon.Heart />
                            </div>
                            <h3>Evcil Hayvan ve Sahip Kaydı</h3>
                            <p>
                                Evcil hayvanların kimlik, tür, ırk ve sahip bilgilerini kayıt altına alarak bütün hasta bilgilerini düzenli biçimde yönetin.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon">
                                <Icon.Activity />
                            </div>
                            <h3>Aşı Takip Sistemi</h3>
                            <p>
                                Planlanan, yaklaşan, zamanı geçmiş ve tamamlanmış aşıları tek ekran üzerinden görüntüleyin. Aşı süreçlerinin gözden kaçmasını önleyin.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon bg-c679e3">
                                <Icon.Clipboard />
                            </div>
                            <h3>Muayene ve Hastalık Takibi</h3>
                            <p>
                                Evcil hayvanların geçmiş muayenelerini, hastalıklarını ve uygulanan tedavileri görüntüleyerek klinik geçmişlerine hızlıca ulaşın.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon bg-c679e3">
                                <Icon.Calendar />
                            </div>
                            <h3>Randevu ve Klinik Ajandası</h3>
                            <p>
                                Muayene ve kontrol tarihlerini dijital ajanda üzerinden planlayarak günlük klinik programınızı daha düzenli yönetin.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon bg-eb6b3d">
                                <Icon.FileText />
                            </div>
                            <h3>Tedavi ve İlaç Uygulama Takibi</h3>
                            <p>
                                Uygulanan ilaçları ve tedavi süreçlerini hayvan bazında kayıt altına alın. Hangi ilacın hangi hastaya uygulandığını kolayca takip edin.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon bg-eb6b3d">
                                <Icon.Package />
                            </div>
                            <h3>İlaç ve Stok Takibi</h3>
                            <p>
                                Kliniğinizde bulunan ilaçları barkod numaralarıyla sisteme kaydedin, kullanılan ürünleri ve mevcut stok durumunu kontrol edin.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon">
                                <Icon.MessageCircle />
                            </div>
                            <h3>WhatsApp ve SMS Hatırlatmaları</h3>
                            <p>
                                Aşı veya kontrol zamanı yaklaşan evcil hayvanların sahiplerine WhatsApp ya da SMS üzerinden bilgilendirme gönderin.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PawiOzellikler;
